export default {
    url: 'delta-3-1000-air-portabe-power-station',
    include: ['jp'],
};
